(function(angular, _) {
    /**
     * @ngdoc object
     * @name AutofocusController
     * @description Directive controller that focuses the element on which it is applied as attribute
     */
    class AutofocusController {
        static get $inject() {
            return ['$timeout', '$element'];
        }

        constructor($timeout, $element) {
            this.$timeout = $timeout;
            this.$element = $element;

            this.timeouts = {};
        }

        $postLink() {
            this.focus();
        }

        $onChanges(changeslist) {
            const autofocus = _.get(changeslist, 'autofocus.currentValue', false);

            if (autofocus) {
                this.focus();
            }
        }

        $onDestroy() {
            _.values(this.timeouts, (timeout) => this.$timeout.cancel(timeout));
        }

        focus() {
            if (this.timeouts.focus) {
                return this;
            }

            this.timeouts.focus = this.$timeout(() => {
                this.$element[0].focus();
                delete this.timeouts.focus;
            });

            return this;
        }
    }

    angular.module('wtUi')
        .directive('autofocus', [function() {
            return {
                scope: {
                    /**
                     * Allows the parent component to re-trigger the autofocus on demand
                     * @type {boolean}
                     * @example Autofocus the search box of a dropdown not only when element is compiled, but also when it is opened
                     * <input type="text" autofocus="$ctrl.open">
                     */
                    autofocus: '<?'
                },
                bindToController: true,
                restrict: 'A',
                controller: AutofocusController
            };
        }]);
})(window.angular, window._);
